
let swiperBlocks = document.querySelectorAll('.swiper');
//let 
// console.log(swiperBlocks)
function carouselRender(){
  swiperBlocks.forEach(block => {
  let swiperSlides = parseInt(block.attributes.slides.value);
  let space = parseInt(block.attributes.space.value);
  let mobSpace = block.attributes.mobileSpace != undefined ? parseInt(block.attributes.mobileSpace.value) : space;
  let ifPagination = block.attributes.pagination != undefined && block.attributes.pagination.value == "true" ? true : false;
    // console.log("pagination", ifPagination)
  let id = block.attributes.id.value;
  let mobSlides = block.dataset.mobSlides != undefined ? parseInt(block.dataset.mobSlides): 'auto';
    console.log("mobile slides", mobSlides, typeof mobSlides);
  let isCenteredMobile = !block.dataset.centered
    let tabAttr;
    if(block.attributes.tabslides != undefined){
     tabAttr = block.attributes.tabslides.value;
    }
  let tabSlides;
  
    if(tabAttr != undefined ){
       tabSlides = parseInt(tabAttr);
    }
    else{
       tabSlides = 2;
    }
    // console.log(tabSlides);
    
  let namespace = '.swiper-' + id;
  let next = '.swiper-next-' + id;
  let prev = '.swiper-prev-' + id;

  const swiper = new Swiper(namespace, {
  // Optional parameters
  direction: 'horizontal',
  slidesPerView: mobSlides,
  spaceBetween: mobSpace ,
  centeredSlides: isCenteredMobile,
      grabCursor: true,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      preloadImages: true,
      updateOnImagesReady: true,
  // Responsive breakpoints
   breakpoints: {
    // when window width is >= 540px
    576: {
          slidesPerView: tabSlides,
          spaceBetween: space,     
      centeredSlides: false,
        },
    // when window width is >= 767px
    767: {
      slidesPerView: swiperSlides,
      spaceBetween: space,     
      centeredSlides: false,
    },
  }, 
	pagination: {
    el: ifPagination ? '.swiper-pagination' : '',
  },  
  // Navigation arrows
  navigation: {
    nextEl: next,
    prevEl: prev,
  },
     speed: 2000,
    autoplay: {
        delay: 5000,
        disableOnInteraction: false,
       
      },

  // And if we need scrollbar
   scrollbar: {
    el: '.swiper-scrollbar',
  }, 
});
  
})
}
document.addEventListener("shopify:section:load", carouselRender);
window.addEventListener('load', carouselRender);
